import { render } from "./ShowCategury.vue?vue&type=template&id=5646b32c"
import script from "./ShowCategury.vue?vue&type=script&lang=js"
export * from "./ShowCategury.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__